import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ProjectBudgetContainerComponent } from './project-budget-container/project-budget-container.component';
const log = new LoggingService();

export const ProjectBudgetRoute: Ng2StateDeclaration = {
    // name: 'ProjectBudget.**'
    name: 'projectbudget',
    url: '/projectbudget',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.ProjectBudgetModule)
    data: { requiresAuth: true },

    component: ProjectBudgetContainerComponent
};
